import React from 'react'
import { render } from 'react-dom'

import { exists } from '../../common/elements'
import Search from './components/Search'

const SearchApp = () => {
  if (!exists('#wwp3-search')) return false

  render(
    <Search className="wwp3-search-app" />,
    document.getElementById('wwp3-search-mount')
  )
}

export default SearchApp



// WEBPACK FOOTER //
// src/assets/js/front-end/apps/search/index.js